import * as DOMHelpers from './DOMHelpers';

export function initialize() {
    disableTargets(document);

    let checkboxes = document.querySelectorAll('[data-spinao-area-checkbox-combinations-allowed] input[type=checkbox]');
    checkboxes.forEach(function (checkbox) {
        if(checkbox.checked) {
            processInput(checkbox as HTMLInputElement);
        }
    });

    document.addEventListener("change", function(targetChange) {
        let target = targetChange.target as HTMLElement;

        if(target.tagName === 'INPUT' && target.getAttribute('type') === 'checkbox') {
            processInput(target as HTMLInputElement);
        }
    });
}

function processInput(input: HTMLInputElement)
{
    let area = DOMHelpers.getMatched(input, '[data-spinao-area-checkbox-combinations]');
    console.log(area);
    if(area) {
        let item = DOMHelpers.getMatched(input, '[data-spinao-area-checkbox-combinations-allowed]');
        if(item) {
            disableTargets(area);

            if(input.checked) {
                let allowed = item.dataset.spinaoAreaCheckboxCombinationsAllowed || '';
                enableTargets(area, allowed.split(','));
            }

            uncheckDisabled(area);
        }
    }
}

function disableTargets(root: HTMLElement|Document)
{
    let targets = root.querySelectorAll('[data-spinao-area-checkbox-combinations-target]');

    targets.forEach(function(target) {
        target.classList.add('disabled');
    });
}

function enableTargets(root: HTMLElement, toAllow: string[])
{
    let selector = '';

    toAllow.forEach(function(item: string) {
        selector += '[data-spinao-area-checkbox-combinations-target="'+item+'"],';
    });

    root.querySelectorAll(selector.substring(0, selector.length - 1)).forEach(function(element) {
        element.classList.remove('disabled');
    });
}

function uncheckDisabled(root: HTMLElement)
{
    let checkboxes = root.querySelectorAll('.disabled[data-spinao-area-checkbox-combinations-target] input[type=checkbox]');
    checkboxes.forEach(function(element) {
        element.checked = false;
    });
}
